<template>
    <div class="generator--parent">
            <div class="container generator grid-container" v-bind:class="{ boxselector: !model}">
                <content-loader v-if="!loaded" :speed="2" :animate="true" :width="300" height="300">
                    <circle cx="150" cy="150" r="100"/>
                </content-loader>
                <BoxSelector v-show="loaded && !model"></BoxSelector>
                <BoxDrawer ref="boxdrawer" v-show="loaded && model" @openboxselector="openBoxSelector"></BoxDrawer>
                <BoxSliders ref="boxsliders" v-show="loaded && model && !showForm" v-on:showForm="showContactForm" max="1500"></BoxSliders>
                <transition name="fade">
                    <ContactForm v-if="showForm" :data="formObject" v-on:cancel="hideContactForm"></ContactForm>
                </transition>
            </div>
        <div class="generator grid-container--form container">

        </div>
    </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader"
import BoxSelector from "@/components/BoxSelector.vue"
import BoxDrawer from "@/components/BoxDrawer.vue"
import BoxSliders from "@/components/BoxSliders.vue"
import ContactForm from "@/components/ContactForm.vue"
import axios from "axios"
import VueAxios from "vue-axios"


export default {
    name: "Generator",
    components: {
        ContentLoader,
        BoxDrawer,
        BoxSelector,
        BoxSliders,
        ContactForm,
        VueAxios,
        axios
    },
    props: {
        mac: String,
        boxId: { Number, default: 0 }
    },
    watch: {
        '$route.params.boxId': function (boxId) {
          this.loaded = true;
          this.model = boxId;
        }
    },
    mounted() {
        this.initData(this.$route.params.mac);
    },
    methods: {
        initData(mac) {
            let axiosEndpoint = process.env.VUE_APP_INIT_DATA_ENDPOINT;
            console.log('osoite: ' + axiosEndpoint);
            var config = {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET",
                    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
                },
                responseType: 'json',
                crossDomain: true
            };
            axios
            .get(axiosEndpoint+'?mac='+mac, config)
            .then(response => {
                var kk = this;
                var boxIdTmp = this.$route.params.boxId;
                console.log('boxIdTmp:', boxIdTmp);
                if(boxIdTmp > 0) {
                    setTimeout(function() {
                        kk.model = boxIdTmp;
                    }, 450);
                }
                setTimeout(function() {
                    kk.loaded = true;
                }, 500);
                console.log('data received:');
                console.log(response.data);
                this.companySettings = response.data;
            })
        },
        showContactForm(formObject) {
            console.log('Form Show, from Generator');
            this.showForm = true;
            this.formObject = formObject;
            this.$refs.boxdrawer.hideButton();
        },
        hideContactForm() {
            console.log('Form Hide, from Generator');
            this.formObject = {};
            this.showForm = false;
            this.$refs.boxdrawer.showButton();
        },
        openBoxSelector() {
            this.loaded = true;
            this.model = false;
        },
    },
    data() {
        return {
            loaded:false,
            companySettings:null,
            imageData:null,
            showForm: false,
            model: false,
            modelName: '',
            formObject: {},
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.fade-enter-active {
  transition: all .5s ease-in-out;
  transform-origin: left bottom;
  transform: scaleY(1);
}
.fade-leave-active {
  transition: none;
  display:none;
}

.fade-enter {
  opacity: 0;
  transform: scaleY(0);
}

.slide-fade-leave-active, slide-fade-enter-active, {
    transition: all .5s ease-in-out;
    transform-origin: left top;
    transform: scaleY(1);
}

.slide-fade-enter, .slide-fade-leave-to{
  opacity: 0;
  transform: scaleY(0);
}

</style>